import Vue from 'vue'
import { Message,MessageBox, Loading } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router';
import { getUserLoginStatus } from './api/api';
import { getUserInfo } from './api/user';
import { addWaterMark } from './common/js/waterMark';
import { addReportParam } from './common/js/track';
import 'reset.less'
import '@/common/less/common.less';

Vue.config.productionTip = false

Vue.use(Loading.directive);
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;


(function injectUrsMessageScript() {
  try {
    var existing = document.getElementById('urs-message-js');
    if (existing) return;
    var script = document.createElement('script');
    script.id = 'urs-message-js';
    script.src = 'https://urswebzj.nosdn.127.net/webzj_cdn101/message.js';
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.onerror = function(err){
      // eslint-disable-next-line no-console
      console.error('Failed to load URS message.js', err);
    };
    document.head.appendChild(script);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
})();
window.addEventListener('load', () => {
  if (window.URS) {
    Vue.prototype.URS = window.URS;
  }

  new Vue({
    router,
    render: h => h(App),
  }).$mount('#app')
});

try {
  getUserLoginStatus().then(res => {
    if (res.code === 200 && res.body.login) {
      getUserInfo().then(res => {
        if (res.code === 200) {
          const {identity, userInfo} = res.body;
          addReportParam('username', identity?.username);
          addReportParam('mobile', userInfo?.mobile);
          addReportParam('userid', userInfo?.id);
          const content = [identity?.username, userInfo?.mobile].filter(item => !!item).join(' ');
          addWaterMark(content)
        }
      })
    }
  })
} catch(e) {
  console.error(e)
}